import config from 'config/env'

const STRAPI_URL = config.STRAPI_URL
const STRAPI_TOKEN = config.STRAPI_TOKEN

const buildHeaders = (headers?: HeadersInit) => {
  const nextHeaders = new Headers(headers)

  if (!nextHeaders.has('Accept')) {
    nextHeaders.set('Accept', 'application/json')
  }

  if (STRAPI_TOKEN && !nextHeaders.has('Authorization')) {
    nextHeaders.set('Authorization', `Bearer ${STRAPI_TOKEN}`)
  }

  return nextHeaders
}

export const strapiFetch = async <T = unknown>(
  path: string,
  init: RequestInit = {}
): Promise<T> => {
  if (!STRAPI_URL) {
    throw new Error('Missing STRAPI_URL environment variable')
  }

  const response = await fetch(`${STRAPI_URL}${path}`, {
    ...init,
    headers: buildHeaders(init.headers),
  })

  if (!response.ok) {
    const message = `Strapi request failed: ${response.status} ${response.statusText}`
    throw new Error(message)
  }

  return (await response.json()) as T
}
